import axios from "axios";
import { TTP_API_URL } from "Config";

export const getAlbums = ({
  token,
  id,
  limit,
  offset = 0,
  community,
  filterBy,
  language = "fr",
  isPersonal = 0
}) => {
  let filter = [];

  if (community && community.id) {
    filter.push({
      property: "organization",
      operator: "eq",
      value: community.id
    });
  }

  if (filterBy && filterBy.search) {
    //TODO search in other fields
    filter.push({
      property: "title",
      operator: "like",
      value: filterBy.search
    });
  }

  if (id) {
    filter.push({
      property: "id",
      operator: "eq",
      value: id
    });
  } else {
    filter.push({
      property: "isPersonal",
      operator: "in",
      value: Array.isArray(isPersonal) ? isPersonal : [isPersonal]
    });
  }

  /*if (filterBy && filterBy.tags && filterBy.tags.length > 0) {
    filter.push({
      property: "tag.id",
      operator: "in",
      value: filterBy.tags.map(tag => tag.id)
    });
  }*/

  // if (filterBy && filterBy.creator) {
  //   filter.push({
  //     property: "creator",
  //     operator: "eq",
  //     value: filterBy.creator.id
  //   });
  // }

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];

  const fields = [
    "*",
    "tags",
    id === null ? "preview" : "medias",
    "color",
    "docType",
    "creator"
  ];
  const requestUrl = `${TTP_API_URL}/media/album`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      limit,
      start: offset
    }
  });
};
export const getMyAlbums = ({
  token,
  communityId,
  userId,
  filterBy = null
}) => {
  let filter = [
    {
      property: "organization",
      operator: "eq",
      value: communityId
    },
    {
      property: "creator",
      operator: "eq",
      value: userId
    }
  ];

  if (filterBy && filterBy.search) {
    //TODO search in other fields
    filter.push({
      property: "title",
      operator: "like",
      value: filterBy.search
    });
  }

  /*if (filterBy && filterBy.tags && filterBy.tags.length > 0) {
    filter.push({
      property: "tag.id",
      operator: "in",
      value: filterBy.tags.map(tag => tag.id)
    });
  }*/

  // if (filterBy && filterBy.creator) {
  //   filter.push({
  //     property: "creator",
  //     operator: "eq",
  //     value: filterBy.creator.id
  //   });
  // }

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];

  const fields = ["*", "preview", "color", "docType", "creator", "createdAt"];
  const requestUrl = `${TTP_API_URL}/media/album`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      limit: 200,
      start: 0
    }
  });
};

export const saveAlbum = ({
  token,
  lng,
  id,
  community,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  color,
  tags,
  mediaIds,
  addMedia
}) => {
  const requestUrl = `${TTP_API_URL}/media/album`;
  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organization", community.id);
  titleFR && formData.append("titleFr", titleFR);
  titleEN && formData.append("titleEn", titleEN);
  titleNL && formData.append("titleNl", titleNL);
  descriptionFR && formData.append("descriptionFr", descriptionFR);
  descriptionEN && formData.append("descriptionEn", descriptionEN);
  descriptionNL && formData.append("descriptionNl", descriptionNL);
  color && formData.append("color", color);
  // formData.append("isPersonal", isPersonal ? 1 : 0);
  id && formData.append("id", id);
  formData.append("addMedia", addMedia ? 1 : 0);
  mediaIds && formData.append("media_ids", JSON.stringify(mediaIds));
  if (tags && tags.length > 0) {
    // const nameAttr = `name${data.language.charAt(0).toUpperCase() + data.language.slice(1)}`;
    tags.forEach((tag, i) => {
      if (tag.id) {
        formData.append(`tags[${i}][id]`, tag.id);
      } else {
        formData.append(`tags[${i}][nameFr]`, tag["nameFr"] || "");
        formData.append(`tags[${i}][nameEn]`, tag["nameEn"] || "");
        formData.append(`tags[${i}][nameNl]`, tag["nameNl"] || "");
      }
    });
  }

  return axios.post(requestUrl, formData);
};

export const deleteAlbum = ({ token, id }) => {
  const requestUrl = `${TTP_API_URL}/media/album/${id}`;
  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("_method", "delete");
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/album.js